// Column definitions for the Interval Community GlobalTable.
// Field names match the LIST endpoint response (/interval-community).
import CommunityLinkCell from './CommunityLinkCell';

export const IntervalCommunityTableHeader = () => [
  { field: 'sl_no', headerName: 'Sl No', width: 90 },
  { field: 'community_id', headerName: 'Community Id', width: 130 },
  { field: 'title', headerName: 'Title', width: 280, toolTipGetter: true },
  {
    field: 'class_name',
    headerName: 'Class',
    width: 130,
    renderCell: (params) => params.row?.class_name || '-',
  },
  {
    //ONLY FILLED FOR A CLASS THAT DOES NOT NEED THE SYLLABUS SPLIT
    field: 'community_link',
    headerName: 'Community Link',
    width: 280,
    renderCell: (params) => <CommunityLinkCell link={params.row?.community_link} />,
  },
  {
    field: 'state_board_link',
    headerName: 'State Board Link',
    width: 280,
    renderCell: (params) => <CommunityLinkCell link={params.row?.state_board_link} />,
  },
  {
    field: 'cbse_link',
    headerName: 'CBSE Link',
    width: 280,
    renderCell: (params) => <CommunityLinkCell link={params.row?.cbse_link} />,
  },
  {
    field: 'createdByName',
    headerName: 'Created By',
    width: 180,
    renderCell: (params) => params.row?.created_user?.name || '-',
    toolTipGetter: true,
  },
  { field: 'created_on', headerName: 'Created On', width: 190, toolTipGetter: true },
  {
    field: 'edit',
    headerName: 'Edit',
    type: 'action',
    actionType: 'edit',
    actionKey: 'editCommunity',
    width: 140,
    buttonName: 'Edit',
  },
  {
    field: 'delete',
    headerName: 'Delete',
    type: 'action',
    actionType: 'delete',
    actionKey: 'deleteCommunity',
    width: 150,
    buttonName: 'Delete',
  },
];
